import axios from '@/libs/api.request'

/**
 * 登录
 */
export const login = (username, password) => {
    const data = {
        "username": username,
        "password": password
    }
    return axios.request({
        url: '/api/admin/login',
        data,
        method: 'post'
    })
}

/**
 * 自动登录
 */
export const singleSignOn = (sid, token) => {
    const data = {
        "sid": sid,
        "token": token
    }
    return axios.request({
        url: '/api/admin/singleSignOn',
        data,
        method: 'post'
    })
}

/**
 * token登录
 */
 export const tokenLogin = (project_id, access_token) => {
    const data = {
        "project_id": project_id,
        "access_token": access_token
    }
    return axios.request({
        url: '/api/admin/tokenLogin',
        data,
        method: 'post'
    })
}

/**
 * 登出
 */
export const loginOut = (username, password) => {
    return axios.request({
        url: '/api/admin/logout',
        method: 'post'
    })
}

/**
 * 修改密码
 */
export const changePass = (oldPass, newPass) => {
    const data ={
        "oldPass": oldPass,
        "newPass": newPass
    }
    return axios.request({
        url: '/api/admin/user/changePassword',
        data,
        method: 'post'
    })
}

/**
 * 修改密码
 */
 export const continueSession = () => {
    return axios.request({
        url: '/api/admin/continueSession',
        method: 'post'
    })
}

/**
 * 超级用户、集团用户 获取项目权限
 */
export const getProjectList = () => {
    return axios.request({
        url: '/api/admin/getProjectList',
        method: 'post'
    })
}
/**
 * 超级用户、集团用户 进入项目权限
 */
export const setProjectList = (project_id) => {
    const data = {
        "project_id": project_id
    }
    return axios.request({
        url: '/api/admin/setProjectList',
        data,
        method: 'post'
    })
}